import React from 'react';
/* Banner requires heading and message, linkAction or linkUrl, and linkDisplay are optional */
export var AsureCloudBanner = function (_a) {
    var heading = _a.heading, message = _a.message, linkAction = _a.linkAction, linkUrl = _a.linkUrl, linkDisplay = _a.linkDisplay, borderColor = _a.borderColor, className = _a.className;
    return (React.createElement("section", { className: "ACBanner shadow-sm d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-start align-items-sm-center border-" + borderColor + " " + className },
        React.createElement("div", { className: "messageArea d-flex flex-column justify-content-center align-items-start pb-sm-0 pb-1" },
            React.createElement("h1", { className: "bannerHeading font-weight-bold m-0 pb-2" }, heading),
            React.createElement("p", { className: "bannerMessage m-0" }, message)),
        React.createElement("div", { className: "linkArea d-flex flex-column justify-content-center align-items-center" },
            linkUrl && React.createElement("a", { href: linkUrl, className: "card-link" }, linkDisplay),
            linkAction && React.createElement("a", { href: "javascript:void(0);", onClick: linkAction, className: "card-link" }, linkDisplay))));
};
export default AsureCloudBanner;
AsureCloudBanner.defaultProps = {
    heading: 'Important Banner Heading',
    message: 'Important banner message to be written here',
    borderColor: 'primary',
    linkDisplay: 'Acknowledge',
    linkUrl: '#'
};
//# sourceMappingURL=Banner.js.map